export default __webpack_public_path__ + "static/media/details-1.a6d44872.jpeg";